// src/components/auth/BusinessSelector.js
import React, { useState } from 'react';
import * as api from '../../api';
import { css } from '../../App';

function BusinessSelector({ selectorToken, businesses, name, onSelect, startRegistration = false }) {
  const [loading, setLoading] = useState(null);
  const [error, setError] = useState("");
  const [showRegister, setShowRegister] = useState(startRegistration);
  const [form, setForm] = useState({ businessName: "", businessType: "manufacturing" });
  const [registering, setRegistering] = useState(false);

  const choose = async (businessId) => {
    setLoading(businessId);
    setError("");
    try {
      const data = await api.selectBusiness(selectorToken, businessId);
      api.saveToken(data.token);
      onSelect(data);
    } catch (e) {
      setError(e.message);
      setLoading(null);
    }
  };

  const submitRegister = async (e) => {
    e.preventDefault();
    if (!form.businessName.trim()) { setError("Business name is required."); return; }
    setRegistering(true);
    setError("");
    try {
      // This email already has a role elsewhere, so registration goes
      // through the selector token directly rather than a fresh
      // "unregistered" one — the backend issues a brand-new real token
      // for the new business, in the same shape choosing an existing
      // one does, so onSelect handles both identically.
      const data = await api.registerBusinessFromSelector(selectorToken, form);
      api.saveToken(data.token);
      onSelect(data);
    } catch (e) {
      setError(e.message);
      setRegistering(false);
    }
  };

  return (
    <><style>{css}</style>
      <div className="login-screen">
        <div className="login-box">
          <div style={{ fontSize: 40, marginBottom: 8 }}>👤</div>
          <h2>Welcome, {name?.split(" ")[0]}</h2>

          {!showRegister ? (
            <>
              <p>Your account is linked to {businesses.length} businesses. Which one do you want to access?</p>
              {error && <div className="alert alert-error">{error}</div>}
              {businesses.map(b => (
                <button key={b.businessId} className="biz-card" onClick={() => choose(b.businessId)} disabled={!!loading}>
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    {b.businessLogo
                      ? <img src={b.businessLogo} alt="" style={{ width: 40, height: 40, borderRadius: 8, objectFit: "cover", flexShrink: 0 }} />
                      : <div style={{ width: 40, height: 40, borderRadius: 8, background: "#e94560", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700, fontSize: 18, flexShrink: 0 }}>{b.businessName[0]}</div>
                    }
                    <div style={{ textAlign: "left" }}>
                      <div style={{ fontWeight: 700, fontSize: 14, color: "#1a1a2e" }}>{b.businessName}</div>
                      <div style={{ fontSize: 11, color: "#6b7280", marginTop: 2 }}>Your role: <strong style={{ textTransform: "capitalize" }}>{b.role}</strong></div>
                    </div>
                    {loading === b.businessId && <span style={{ marginLeft: "auto", fontSize: 11, color: "#9ca3af" }}>Signing in…</span>}
                  </div>
                </button>
              ))}

              <div className="divider" style={{ margin: "16px 0" }} />
              <button className="btn btn-secondary" style={{ width: "100%" }} onClick={() => { setShowRegister(true); setError(""); }}>
                🏪 Register a new business
              </button>
              <p style={{ fontSize: 11, color: "#9ca3af", marginTop: 8 }}>
                None of these your own? Set up your own business on the free Trial plan — instantly, no approval wait.
              </p>
            </>
          ) : (
            <form onSubmit={submitRegister}>
              <p style={{ fontSize: 13, color: "#6b7280", marginBottom: 16 }}>
                This lands on the free <strong>Trial</strong> plan immediately — your existing roles at other businesses aren't affected.
              </p>
              {error && <div className="alert alert-error">{error}</div>}
              <div style={{ textAlign: "left", marginBottom: 10 }}>
                <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 4, textTransform: "uppercase", letterSpacing: .4 }}>Business Name *</label>
                <input type="text" value={form.businessName} onChange={e => setForm(f => ({ ...f, businessName: e.target.value }))}
                  placeholder="e.g. Khalid Footwear" autoFocus
                  style={{ width: "100%", padding: "9px 12px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 13, color: "#1a1a2e", outline: "none" }} />
              </div>
              <div style={{ textAlign: "left", marginBottom: 16 }}>
                <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 4, textTransform: "uppercase", letterSpacing: .4 }}>Business Type</label>
                <select value={form.businessType} onChange={e => setForm(f => ({ ...f, businessType: e.target.value }))}
                  style={{ width: "100%", padding: "9px 12px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 13, color: "#1a1a2e", outline: "none" }}>
                  <option value="manufacturing">Manufacturing (production + orders + walk-in)</option>
                  <option value="retail_only">Retail Only (buy and resell, no custom orders)</option>
                  <option value="service_only">Service Only (custom orders, no walk-in sales)</option>
                  <option value="custom">Custom — adjust modules later in Settings</option>
                </select>
              </div>
              <button type="submit" className="btn btn-primary" style={{ width: "100%", marginBottom: 8 }} disabled={registering}>
                {registering ? "Setting up your workspace…" : "🚀 Create My Business"}
              </button>
              <button type="button" className="btn btn-secondary" style={{ width: "100%", fontSize: 12 }}
                onClick={() => { setShowRegister(false); setError(""); }} disabled={registering}>
                ← Back to business list
              </button>
            </form>
          )}
        </div>
      </div></>
  );
}

export default BusinessSelector;